import { render, staticRenderFns } from "./StatusError.vue?vue&type=template&id=28685080"
import script from "./StatusError.vue?vue&type=script&lang=js"
export * from "./StatusError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports